import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import RecoverModal from '../../components/modals/recoverModal';
import PosForm from './posForm';
import VoidModal from '../../components/modals/voidModal';
import ViewModal from '../../components/modals/viewModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import { FcViewDetails } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalInFormatter, totalOutFormatter } from '../../components/formatters/numberFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter } from '../../components/formatters/defFormatter';
import { createdHourFormatter, dateFormatter, dateTableFormatter, dateTableFormatterWithoutHour } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { selectStyles } from '../../components/dropDown/selectStyle';

import { DataContext } from '../../init/getData';




function PosSales(props) {

  let { type, isDebit, refreshTable, setRefreshTable, refFetchData } = props;

  const { userData, settingData, defaultCurrency, mainCurrency, companyId, allUserOptions, branchId, branchOptions,
    yearId, serverApi, localApi, devData, contentLanguages } = useContext(DataContext);

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);

  const isOffline = devData?.isOffline;


  const createdBy = userRole.viewAllUsers ? null : parseInt(userData.id);
  const roundTo = settingData.roundTo;

  const table = 'journalVoucher';
  const title = type;

  let api;
  if (devData?.isServer) {
    api = localApi;
  }
  else if (devData?.isOffline) {
    api = localApi;
  }
  else if (devData?.isClient) {
    api = serverApi;
  }

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', fromDate: today, toDate: today, type, companyId, yearId, createdBy, isOffline: devData?.isOffline });


  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [editedJv, setEditedJv] = useState(false);


  const selectedBranch = useMemo(() => {
    if (!userRole.viewAllBranches) {
      setFilter((prev) => ({ ...prev, branchId: branchId }));
      return branchOptions?.find(option => option.value === branchId);
    }
    return branchOptions?.find(option => option.value === filter.branchId);
  }, [userRole.viewAllUsers, filter.branchId]);


  const selectedUser = useMemo(() => {
    if (!userRole.viewAllUsers) {
      setFilter((prev) => ({ ...prev, createdBy: createdBy }));
      return allUserOptions?.find(option => option.value === createdBy);
    }
    return allUserOptions?.find(option => option.value === filter.createdBy);
  }, [allUserOptions, filter.createdBy]);

  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }


  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const editModal = (e) => {
    if (!showModal && e) {
      setEditedJv(e);
    }
    else {
      setEditedJv(null);
    }
    setShowModal(!showModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => ({
      ID: item.id,
      CreatedAt: createdHourFormatter(item.createdAt),
      Date: item.date,
      Type: item.type,
      Payment: item.paymentType,
      Account: item.account?.english || '',
      Delivery: item.delivery?.name || '',
      "Total In": item.debit,
      "Total Out": item.credit,
      Details: item.details,
      Status: item.status,
    }));

    return { transformedData };
  };


  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.CreatedAt, dataIndex: 'createdAt', width: '6%', render: dateTableFormatter },
    { title: contentLanguages.Type, dataIndex: 'type' },
    { title: contentLanguages.Payment, dataIndex: 'paymentType', render: paymentTypeFormatter },
    { title: contentLanguages.Account, dataIndex: 'account', render: (account) => (account?.english), width: '10%' },
    { title: contentLanguages.Delivery, dataIndex: 'delivery', width: '8%', render: (delivery) => (delivery?.name) },
    { title: contentLanguages.TotalIn, dataIndex: 'debit', width: '8%', render: totalInFormatter },
    { title: contentLanguages.TotalOut, dataIndex: 'credit', width: '8%', render: totalOutFormatter },
    { title: contentLanguages.Details, dataIndex: 'details', width: '14%' },
    { title: contentLanguages.Status, dataIndex: 'status', render: statusFormatter },
    {
      title: contentLanguages.View,
      width: '5%',
      render: (_, record) => (
        <FcViewDetails size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
      ),
    },
    userRole?.allowEdit && {
      title: contentLanguages.Edit,
      width: '5%',
      render: (_, record) => (
        <FiEdit size={15} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
      ),
    },
    {
      title: contentLanguages.Void,
      width: '5%',
      render: (_, record) => (record.isActive ? (
        <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} />
      ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
      )
    }
  ].filter(Boolean), []);

  const tableFooter = (
    <div >

    </div>
  )

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>
          <div>
            <Row className='g-2 mb-3'>

              <Col md={2}>
                <SearchFilter setFilter={setFilter} />
              </Col>

              <Col md={3}>
                <DatePicker setFilter={setFilter} filter={filter} />
              </Col>

              <Col md={2}>
                <Select
                  styles={selectStyles}
                  options={branchOptions}
                  isSearchable={true}
                  isClearable={true}
                  required
                  placeholder={'Select Branch...'}
                  value={selectedBranch}
                  onChange={(e) => handleSelectChange(e, 'branchId')}
                  isDisabled={!userRole.viewAllBranches}
                />
              </Col>


              <Col md={2}>
                <Select
                  styles={selectStyles}
                  options={allUserOptions}
                  isSearchable={true}
                  isClearable={true}
                  required
                  placeholder={'Select User...'}
                  value={selectedUser}
                  onChange={(e) => handleSelectChange(e, 'createdBy')}
                  isDisabled={!userRole.viewAllUsers}
                />
              </Col>


              <Col md={1}>
                <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                  <FiFilter size={15} color='white' />
                </Button>
              </Col>

              <Col md={2} className="d-flex justify-content-end">
                <Button onClick={refreshTableFunction}>
                  <FiPrinter size={18} />
                </Button>
                <Button onClick={refreshTableFunction}>
                  <FiRotateCcw size={18} />
                </Button>
              </Col>

            </Row>

            <SimpleTable
              filter={filter}
              table={table}
              title={title}
              columnDefs={newColumnDefs}
              idRow={idRow}
              setIdRow={setIdRow}
              refreshTable={refreshTable}
              data={data}
              setData={setData}
              tableFooter={tableFooter}
              api={api}
              getExcelData={getExcelData}
              selection={true}
              height={true}
            />


          </div>

          {showDeleteModal &&
            <VoidModal
              showModal={showDeleteModal}
              toggleModal={deleteModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow?.id, journalVoucher: idRow, isOffline }}
            />
          }

          {recoverModal &&
            <RecoverModal
              showModal={showRecoverModal}
              toggleModal={recoverModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow?.id, journalVoucher: idRow, isOffline }}
            />
          }

          {showViewModal &&
            <ViewModal
              showModal={showViewModal}
              toggleModal={viewModal}
              journalVoucher={idRow}  
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow?.id, journalVoucher: idRow }} 
            />
          }

          {showModal &&
            <PosForm
              showModal={showModal}
              toggleModal={editModal}
              refFetchData={refFetchData}
              editedJv={editedJv}
              refreshTableFunction={refreshTableFunction}
            />
          }

        </div>
      }


    </div>
  )
}

export default PosSales;
